let originalMainHtml = '';
let originalThumbHtml = '';
document.addEventListener('DOMContentLoaded', function () {
  originalMainHtml = document.querySelector(
    '#main-carousel .splide__list'
  ).innerHTML;
  originalThumbHtml = document.querySelector(
    '#thumbnail-carousel .splide__list'
  ).innerHTML;
  const urlParams = new URLSearchParams(window.location.search);
  const variantId = urlParams.get('variant');
  const selectedVariant = variantId
    ? document.querySelector(`.swatch-element input[type="radio"][value="${variantId}"]`)
    : document.querySelector('.swatch-element input[type="radio"]:checked');
  if (selectedVariant) {
    const images = JSON.parse(selectedVariant.dataset.images || '[]');
    if (images.length) {
      updateVariantGallery(images);
    } else {
      initializeSplide();
    }
  } else {
    initializeSplide();
  }
  document.addEventListener('change', function (e) {
    const variantInput = e.target.closest('.swatch-element input[type="radio"]');
    if (!variantInput) return;
    const swatchElement = variantInput.closest('.swatch-element');
    const variantTag = document.querySelector('.product_swatch_colors_value');
    if (variantTag) {
      variantTag.textContent = swatchElement.dataset.value;
    }
    const productInfo = variantInput.closest('.l-pdp-product_info_inner');
    if (productInfo) {
      const price = variantInput.getAttribute('variantPrice');
      const comparePrice = variantInput.getAttribute('variantRackRate');
      const availability = variantInput.getAttribute('is_variant_available');
      const variantId = variantInput.value;
      const sku = variantInput.getAttribute('variant-sku');
      const discountPer = variantInput.getAttribute('discount');
      const priceElement = productInfo.querySelector('.rack-rate');
      const salePriceElement = productInfo.querySelector('.saling_price');
      const discount = productInfo.querySelector('.discount_label ');
      console.log(discountPer, "discountPer")
      if (discount) {
        discount.textContent = discountPer;
      }
      if (priceElement) {
        priceElement.textContent = comparePrice;
      }
      if (salePriceElement) {
        salePriceElement.textContent = price;
      }
      const skuElement = document.querySelector('.b-pdp_accordion-product_code');
      if (skuElement) {
        skuElement.textContent = sku;
      }
      const addToCartBtn = productInfo.querySelector('#main-product-handle-btn');
      if (addToCartBtn) {
        addToCartBtn.setAttribute('product_variantid', variantId);
        if (availability === 'true') {
          addToCartBtn.textContent = 'Add to Bag';
          addToCartBtn.removeAttribute('disabled');
        } else {
          addToCartBtn.textContent = 'Out Of Stock';
          addToCartBtn.setAttribute('disabled', 'disabled');
        }
      }
      window.history.replaceState(
        null,
        null,
        `${window.location.pathname}?variant=${variantId}`
      );
    }
    const images = JSON.parse(variantInput.dataset.images || '[]');
    if (images.length) {
      updateVariantGallery(images);
    } else {
      restoreOriginalGallery();
    }
  });
});
function initializeSplide() {
  window.mainSplide = new Splide('#main-carousel', {
    type: 'slide',
    rewind: true,
    pagination: false,
    arrows: true,
     breakpoints: {
      600: {
       pagination: true,
      }
    }
  });
  window.thumbSplide = new Splide('#thumbnail-carousel', {
    direction: 'ttb',
    height: '640px',
    fixedWidth: 94,
    fixedHeight: 94,
    gap: 10,
    arrows: false,
    pagination: false,
    isNavigation: true,
    breakpoints: {
        1800: {
      height: '640px' // 1401px to 1600px
    },
      1600: {
      height: '530px' // 1401px to 1600px
    },

    1400: {
      height: '665px' // 1400px aur usse niche
    },
     1024: {
      height: '400px' 
    },
      600: {
        fixedWidth: 70,
        fixedHeight: 70,
        direction: 'ltr'
      }
    }
  });
  window.mainSplide.sync(window.thumbSplide);
  window.mainSplide.mount();
  window.thumbSplide.mount();
}
function updateVariantGallery(images) {
  window.mainSplide?.destroy(true);
  window.thumbSplide?.destroy(true);

  const isVideo = url => /\.(mp4|webm|mov|m3u8)(\?|#|$)/i.test(url);

  const slides = images.map(url => `
    <li class="splide__slide">
      ${
        isVideo(url)
          ? `<video autoplay loop muted playsinline preload="metadata" class="w-100 h-auto">
              <source src="${url}" type="video/mp4">
            </video>`
          : `<img src="${url}" alt="" loading="lazy">`
      }
    </li>
  `).join('');

  document.querySelector('#main-carousel .splide__list').innerHTML = slides;
  document.querySelector('#thumbnail-carousel .splide__list').innerHTML = slides;

  initializeSplide();
  window.mainSplide.go(0);
}
function restoreOriginalGallery() {
  window.mainSplide?.destroy(true);
  window.thumbSplide?.destroy(true);
  document.querySelector('#main-carousel .splide__list').innerHTML =
    originalMainHtml;
  document.querySelector('#thumbnail-carousel .splide__list').innerHTML =
    originalThumbHtml;
  initializeSplide();
  window.mainSplide.go(0);
}